import React from "react";
import gql from "graphql-tag";
import { Subscription } from "react-apollo";

// Fires only on an actual change to this user's own account (the backend keys the
// topic by the logged-in user id and does not replay on connect), so a temporary
// role elevation/revert from the manual-mode relay reloads just the affected
// session. The reload is what recomputes the sidebar/routes for the new role.
const CURRENT_USER_UPDATED = gql`
  subscription {
    currentUserUpdated {
      id
      role
    }
  }
`;

const CurrentUserSubscriber = () => (
  <Subscription
    subscription={CURRENT_USER_UPDATED}
    fetchPolicy="no-cache"
    onSubscriptionData={({ subscriptionData }) => {
      const data = subscriptionData && subscriptionData.data;
      if (data && data.currentUserUpdated) {
        window.location.reload();
      }
    }}
  >
    {() => null}
  </Subscription>
);

export default CurrentUserSubscriber;
